export enum shareEnum {
  CLASS_III,
  CLASS_IV
}

export enum typeCodeEnum {
  COMPONENT = '832',
  CLASS = '831'
}
